'use client'


import { AnimatePresence, motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useMemo, useState } from 'react'

export type Clinic = {
    id: number | string
    name: string
    clinic_address?: string
    thumbnail_display?: string | null
}

type PartnerClinicSliderProps = {
    clinics: Clinic[]
}

const chunkClinics = (items: Clinic[], size: number) => {
    if (!items.length) return []
    const chunks: Clinic[][] = []
    for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size))
    }
    return chunks
}

const PartnerClinicSlider = ({ clinics }: PartnerClinicSliderProps) => {
    // console.log(clinics, "razi")
    const slides = useMemo(() => chunkClinics(clinics, 4), [clinics])
    const [current, setCurrent] = useState(0)

    useEffect(() => {
        if (slides.length <= 1) return
        const id = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length)
        }, 4500)
        return () => clearInterval(id)
    }, [slides.length])

    if (!slides.length) return null

    return (
        <div className='relative overflow-hidden'>
            <AnimatePresence mode='wait' initial={false}>
                <motion.div
                    key={current}
                    initial={{ opacity: 0, x: 60 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -60 }}
                    transition={{ duration: 0.6, ease: 'easeInOut' }}
                    className='grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-8'
                >
                    {slides[current].map((clinic) => (
                        <Link key={clinic.id} href={`/clinic/detail/${clinic.id}`}>
                            <div
                                className={`
                  flex h-full flex-col overflow-hidden rounded-lg bg-[#FAFAFA] shadow-md
                  transition-shadow hover:shadow-lg
                `}
                            >
                                <div className='flex flex-col px-8'>
                                    <div className='relative mt-10 h-64 w-full overflow-hidden bg-[#FAFAFA]'>
                                        <Image
                                            src={clinic.thumbnail_display || '/icons/dtclinic.png'}
                                            alt={clinic.name}
                                            fill
                                            className='rounded-md object-contain'
                                        />
                                    </div>
                                    <div className='flex flex-col gap-3 py-8'>
                                        <div className='space-y-1 text-start md:-mt-2'>
                                            <h2 className='text-lg font-semibold text-[#0D253D] md:text-[20px]'>{clinic.name}</h2>
                                            <p className='truncate text-sm text-[#0D253D]'>{clinic.clinic_address}</p>
                                        </div>

                                        <div className='flex flex-row items-center justify-between'>
                                            <span className='flex flex-col'>
                                                <p className='my-2 text-[16px] text-[#18EE71]'>Verified Profile</p>
                                            </span>
                                        </div>
                                        <div className='flex flex-row items-center justify-between'>
                                            <div>
                                                <p className='text-start text-[18px] text-[#0D253D]'>Psychiatry</p>
                                            </div>
                                            <div className='mt-3 flex justify-center'>
                                                <div
                                                    className={`
                            flex items-center rounded-2xl border bg-white px-2 py-1
                          `}
                                                >
                                                    <Image src='/images/star1.png' alt='rating' height={19} width={20} />
                                                    <span className='ml-2 text-[12px] font-normal text-black'>4.5</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </motion.div>
            </AnimatePresence>
        </div>
    )
}

export default PartnerClinicSlider

